module.exports = __webpack_public_path__ + "static/media/Design Review.2596a255.png";